exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-InputWithButton {\n  width: 100%; }\n\n.m-InputWithButton__input {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch; }\n\n.m-InputWithButton__input--highlight {\n  border-color: #005091; }\n\n.m-InputWithButton__input--gray-bg {\n  border-color: transparent !important;\n  background: #f4f4f4; }\n\n.m-InputWithButton__button {\n  position: relative;\n  flex-shrink: 0;\n  padding-right: 2rem;\n  padding-left: 2rem; }\n", ""]);

// exports
